import { KeyOf } from '~/types';

export const fontStyle = {
  Heading: {
    h1_bold: 'font-size: 40px; font-weight: 700; line-height: 1.2;',
  },

  title: {
    main48_bold:
      'font-size: 48px; font-weight: 700; line-height: 1.1; letter-spacing: -0.04em;',
    main40_bold:
      'font-size: 40px; font-weight: 700; line-height: 1.1; letter-spacing: -0.04em;',
    main36_bold:
      'font-size: 36px; font-weight: 700; line-height: 1.1; letter-spacing: -0.04em;',
    main32_bold:
      'font-size: 32px; font-weight: 700; line-height: 1.2; letter-spacing: -0.04em;',
    sub28_medium:
      'font-size: 28px; font-weight: 500; line-height: 1.2; letter-spacing: -0.02em;',
    sub24_medium:
      'font-size: 24px; font-weight: 500; line-height: 1.2; letter-spacing: -0.02em;',
    sub20_medium:
      'font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.02em;',
    section28_bold:
      'font-size: 28px; font-weight: 700; line-height: 1.2; letter-spacing: -0.02em;',
    section28_medium:
      'font-size: 28px; font-weight: 500; line-height: 1.2; letter-spacing: -0.02em;',
    section24_bold:
      'font-size: 24px; font-weight: 700; line-height: 1.2; letter-spacing: -0.02em;',
    section24_medium:
      'font-size: 24px; font-weight: 500; line-height: 1.2; letter-spacing: -0.02em;',
    section20_bold:
      'font-size: 20px; font-weight: 700; line-height: 1.2; letter-spacing: -0.02em;',
    section20_medium:
      'font-size: 20px; font-weight: 500; line-height: 1.2; letter-spacing: -0.02em;',
    section18_medium:
      'font-size: 18px; font-weight: 500; line-height: 1.2; letter-spacing: -0.02em;',
  },
  text: {
    body18_bold:
      'font-size: 18px; font-weight: 700; line-height: 1.4; letter-spacing: -0.02em;',
    body18_medium:
      'font-size: 18px; font-weight: 500; line-height: 1.4; letter-spacing: -0.02em;',
    body18_regular:
      'font-size: 18px; font-weight: 400; line-height: 1.4; letter-spacing: -0.02em;',
    body16_bold:
      'font-size: 16px; font-weight: 700; line-height: 1.4; letter-spacing: -0.02em;',
    body16_medium:
      'font-size: 16px; font-weight: 500; line-height: 1.4; letter-spacing: -0.02em;',
    body16_regular:
      'font-size: 16px; font-weight: 400; line-height: 1.4; letter-spacing: -0.02em;',
    body14_bold:
      'font-size: 14px; font-weight: 700; line-height: 1.4; letter-spacing: -0.02em;',
    body14_medium:
      'font-size: 14px; font-weight: 500; line-height: 1.4; letter-spacing: -0.02em;',
    body14_regular:
      'font-size: 14px; font-weight: 400; line-height: 1.4; letter-spacing: -0.02em;',
    caption_medium:
      'font-size: 12px; font-weight: 500; line-height: 1.4; letter-spacing: -0.02em;',
    caption_regular:
      'font-size: 12px; font-weight: 400; line-height: 1.4; letter-spacing: -0.02em;',
  },
  label: {
    button16_medium:
      'font-size: 16px; font-weight:500; line-height: 1; letter-spacing: -0.02em;',
    button14_medium:
      'font-size: 14px; font-weight:500; line-height: 1; letter-spacing: -0.02em;',
    list16_medium:
      'font-size: 16px; font-weight:500; line-height: 1.1; letter-spacing: -0.02em;',
    list14_medium:
      'font-size: 14px; font-weight:500; line-height: 1.2; letter-spacing: -0.02em;',
    list12_medium:
      'font-size: 12px; font-weight:500; line-height: 1.1; letter-spacing: -0.02em;',
  },
  poppins: {
    main: 'font-family: "Poppins", sans-serif; font-size: 18px; font-weight: 500; line-height: 1.1; letter-spacing: -0.03em;',
    title:
      'font-family: "Poppins", sans-serif; font-size: 20px; font-weight: 600; line-height: 1.2; letter-spacing: -0.03em;',
    sub_title:
      'font-family: "Poppins", sans-serif; font-size: 18px; font-weight: 600; line-height: 1.2; letter-spacing: -0.03em;',
    desc: 'font-family: "Poppins", sans-serif; font-size: 14px; font-weight: 500; line-height: 1.4; letter-spacing: -0.03em;',
    desc2:
      'font-family: "Poppins", sans-serif; font-size: 16px; font-weight: 400; line-height: 1.4; letter-spacing: -0.03em;',
    desc2_bold:
      'font-family: "Poppins", sans-serif; font-size: 16px; font-weight: 500; line-height: 1.4; letter-spacing: -0.03em;',
  },
} as const;

export type FontStyle = typeof fontStyle;
export type FontStyleKeys = KeyOf<typeof fontStyle>;

type DeepKeyOf<T> = {
  [K in keyof T]: K extends string
    ? T[K] extends object
      ? `${K}.${DeepKeyOf<T[K]>}`
      : K
    : never;
}[keyof T];

export type FontStyleDeepKeys = DeepKeyOf<FontStyle>;
